import { BundlePaymentPlan } from 'multirpc-sdk';

import { PACKAGE_BUNDLE_ID } from '../const';

export const isPackagePlan = (currentPlan?: BundlePaymentPlan) =>
  currentPlan?.bundle.bundle_id === PACKAGE_BUNDLE_ID;
